module.exports = __webpack_public_path__ + "static/EPD-logo_tri_chi-e091b58b65fbbbdacb8ecb11d3f834dd.jpg";